
import Vue from "vue";
import { Component } from "vue-property-decorator";
import { getOrgCodeListByPage } from "@/api/service";
import { LogHelper } from "@/common/LogHelper";
// import * as bindobject from "@/views/scanforacceptpacketgeton/bindobject";

@Component({
  name: "DestinationOrgcodename",
  components: {
    // SingleStatistical,
    // Breadcrumb,
    // Hamburger,
  },
  props: {
    destinationorgdialogshowFlag: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    destinationorgdialogshowFlag(newone, oldone) {
      if (newone) {
        this.destinationorgcodenameDialogFormVisible = true;
        try {
          this.finddestinationorgcodename();
        } catch (error) {
          LogHelper.Error("destinationorgdialogshowFlag失败");
          LogHelper.Error(error);
        }
      }
    },
  },
})
export default class extends Vue {
  public selectElementContents(el) {
    //失去焦点，获取焦点
    // el.blur();
    el.focus();
  }
  public openDialog(formName) {
    this.$nextTick(function () {
      this.selectElementContents(
        document.getElementById("input_destinationorgcodename")
      );
    });
  }
  private registedObj1 = null;
  private curPagedestinationorgcodename = 1;
  private currentrowdestinationorgcodename = null;
  private destinationorgcodenamepagination = 100;
  private destinationorgcodenameDialogFormVisible = false;
  private destinationorgcodenameform = {
    destinationorgcodename: "",
  };
  private tableDatadestinationorgcodename = [];

  private destinationorgcodenameDialogFormOK(flag) {
    LogHelper.Console("|FUNC|destinationorgcodenameDialogFormOK:" + flag);
    if (flag) {
      //接口查询
      if (this.currentrowdestinationorgcodename != null) {
        this.$emit(
          "destinationorgcodename",
          this.currentrowdestinationorgcodename
        );
      } else {
        LogHelper.Console(
          "|FUNC|destinationorgcodenameDialogFormOK:" + "未选择目的网点"
        );
        return;
      }
    } else {
      this.$emit("destinationorgcodename", null); //返回空对象
    }
    this.destinationorgcodenameDialogFormVisible = false;
    this.destinationorgcodenameform.destinationorgcodename = "";
  }

  private tablehandleCurrentChangedestinationorgcodename(val) {
    LogHelper.Console("|FUNC|tablehandleCurrentChangedestinationorgcodename");
    LogHelper.Console(val);
    this.currentrowdestinationorgcodename = val;
  }

  private doubleclickselectdestinationorgcodename(row) {
    LogHelper.Console("|FUNC|doubleclickselectdestinationorgcodename");
    LogHelper.Console(row);
    this.destinationorgcodenameDialogFormVisible = false;

    this.$emit("destinationorgcodename", row);
    this.destinationorgcodenameform.destinationorgcodename = "";
  }

  private searchdestinationorgcodename() {
    LogHelper.Console("|FUNC|searchdestinationorgcodename");
    if (typeof (obj_HttpRequest_Core) == "undefined") {
      // obj_Common.getOrgCodeListByPage(
      //   10,
      //   1,
      //   this.destinationorgcodenameform.destinationorgcodename,
      //   this.initdestinationorg
      // );
    } else {
      let responseStr = this.GetOrgCodeListByPage(
        10,
        1,
        this.destinationorgcodenameform.destinationorgcodename
      );
      this.initdestinationorg(responseStr);
    }

    this.curPagedestinationorgcodename = 1;
  }

  private handleCurrentChangedestinationorgcodename(val) {
    LogHelper.Console("|FUNC|handleCurrentChangedestinationorgcodename");
    LogHelper.Console(val);
    if (typeof (obj_HttpRequest_Core) == "undefined") {
      // obj_Common.getOrgCodeListByPage(
      //   10,
      //   val,
      //   this.destinationorgcodenameform.destinationorgcodename,
      //   this.initdestinationorg
      // );
    } else {
      let responseStr = this.GetOrgCodeListByPage(
        10,
        val,
        this.destinationorgcodenameform.destinationorgcodename
      );
      this.initdestinationorg(responseStr);
    }
  }

  public finddestinationorgcodename() {
    LogHelper.Console("|FUNC|finddestinationorgcodename");

    this.destinationorgcodenameDialogFormVisible = true;
    if (typeof (obj_HttpRequest_Core) == "undefined") {
      // obj_Common.getOrgCodeListByPage(
      //   10,
      //   1,
      //   this.destinationorgcodenameform.destinationorgcodename,
      //   this.initdestinationorg
      // );
    } else {
      let responseStr = this.GetOrgCodeListByPage(
        10,
        1,
        this.destinationorgcodenameform.destinationorgcodename
      );
      this.initdestinationorg(responseStr);
    }
  }
  private GetOrgCodeListByPage(pageSize, current, filter) {
    let body = {
      queryValue: filter, //过滤字符串
      queryType: "19",
      viewType: "1",
      extend1: current.toString(), //当前页
      extend2: pageSize.toString(), //页大小
      extend3: "", //过滤字段
    };
    let job = {
      devMac: "00-00-00-00-00-00",
      devType: "0",
      body: body,
    };

    var result = getOrgCodeListByPage(JSON.stringify(job));
    if (result != null && result.length > 0) {
      try {
        return result;
      } catch (ex) {
        LogHelper.WriteLog("获取网点失败：" + ex);
      }
    } else {
      return {};
    }
  }
  //初始化目的网点数据
  private initdestinationorg(datas): void {
    LogHelper.Console("|FUNC|initdestinationorg");
    var jsonobj = JSON.parse(datas);
    if (jsonobj.respcode == "000") {
      var alldestinationorgs = jsonobj.data.busiData.records;
      LogHelper.Console(alldestinationorgs);
      this.tableDatadestinationorgcodename = alldestinationorgs;
      this.destinationorgcodenamepagination = jsonobj.data.busiData.total;
    } else {
      LogHelper.Console(jsonobj);
    }
  }
}
